<template>
    <section id="app">
        <!-- <button @click="bbb"> dffd</button> -->
        <!--头部信息-->
        <header
            class="top-box bg-white hearde-top-box"
            v-if="NowPath !== '/Customerservice'"
        >
            <!--logo 、 登录、注册 、用户名-->
            <div class="logo-box container flex-jf-btw">
                <!-- logo -->
                <p><img src="./assets/img/logo.jpg" /></p>
                <!-- 登录、注册 按钮 -->
                <div class="login-register-box">
                    <!--已登录-->
                    <div
                        v-if="userInfo.userName || userInfo.mobilePhone"
                        class="logined txt-right"
                    >
                        <p>
                            <span>欢迎您，</span>
                            <router-link
                                v-if="userInfo.userName || userInfo.mobilePhone"
                                to="/accountmanagement"
                            >
                                {{ userInfo.userName || userInfo.mobilePhone }}
                            </router-link>
                            <span
                                @click="loginOut('/login')"
                                class="cur-pot"
                                style="padding-left: 0.5rem"
                                >退出</span
                            >
                        </p>
                        <p class="txt-gray-g-g" v-if="userInfo.lastLoginTime">
                            上次登录：{{ userInfo.lastLoginTime }}
                        </p>
                    </div>
                    <!--未登录-->
                    <p v-else class="font-size-12">
                        <span class="cur-pot" @click="loginOut('/login')"
                            >登录
                        </span>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span
                            class="cur-pot"
                            @click="loginOut('/register/phone')"
                            >注册</span
                        >
                    </p>
                </div>
            </div>
            <!--导航栏-->
            <nav class="nav-box">
                <div class="container flex">
                    <p>
                        <a href="https://www.tkfunds.com.cn/" target="_blank"
                            >首页</a
                        >
                    </p>
                    <p class="active">
                        <a
                            @click="$router.push({ path: '/login' })"
                            class="cur-pot"
                            >网上交易</a
                        >
                    </p>
                    <p>
                        <a
                            href="https://www.tkfunds.com.cn/products/index.html"
                            target="_blank"
                            >基金超市</a
                        >
                    </p>
                    <p>
                        <!-- @click="Customerservice()" -->
                        <a
                            href="https://www.tkfunds.com.cn/service/index.html"
                            target="_blank"
                            >客户服务</a
                        >
                    </p>
                    <p>
                        <a
                            href="https://www.tkfunds.com.cn/aboutus/index.html"
                            target="_blank"
                            >关于我们</a
                        >
                    </p>
                </div>
            </nav>
            <!--重要通知-->
            <div class="news-box flex" v-if="isShowHome_ZYTZ">
                <div class="container flex" style="height: 19px">
                    <p class="text-r">
                        <span class="icon-volume-up txt-red"></span>
                        <span class="">&nbsp;</span>
                    </p>
                    <p
                        style="
                            height: 19px;
                            overflow: hidden;
                            margin-left: 1rem;
                            cursor: pointer;
                        "
                        @click="messageInfo()"
                    >
                        {{ headMessage }}
                    </p>
                </div>
            </div>
            <!--公告弹框"-->
            <div class="ggtk-box" v-if="isShowHome_synopsis">
                <div>
                    <div class="ggtk-top flex-jf-btw">
                        <p><i class="fa fa-bell-o"></i>系统公告</p>
                        <p>
                            <img
                                @click="clearGGTK('1')"
                                src="../static/img/qbjj_gb.png"
                            />
                        </p>
                    </div>
                    <div class="ggtk-content">
                        {{
                            home_synopsis.length > 210
                                ? home_synopsis.substr(0, 210)
                                : home_synopsis
                        }}
                        <span
                            v-if="home_synopsis.length > 210"
                            @click="clearGGTK('2')"
                            class="btn-a-hover txt-blue"
                            >查看详情</span
                        >
                    </div>
                </div>
            </div>
        </header>
        <!--路由-->
        <router-view
            @setScroll="setScrollHandel"
            @showErrorMsgMini="showErrorMsgMini"
            @fdRiskLevel="fdRiskLevel"
            @delStateInfo="delStateInfo"
            @upStateInfo="upStateInfo"
        />
        <!--页脚信息-->
        <footer
            class="foot-box txt-center"
            v-if="NowPath !== '/Customerservice'"
        >
            <!--友情链接 、 联系我们-->
            <div>
                <div class="container flex">
                    <div class="foot-info-lf">
                        <p class="txt-white">友情链接</p>
                        <ul class="flex txt-gray">
                            <li>
                                <a
                                    href="http://www.taikangasset.cn/"
                                    target="_blank"
                                    class="txt-white"
                                >
                                    泰康资产
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://www.csrc.gov.cn/pub/newsite/"
                                    target="_blank"
                                    class="txt-white"
                                    >中国证券监督管理委员会
                                </a>
                            </li>
                            <li>
                                <a
                                    href="http://www.amac.org.cn/"
                                    target="_blank"
                                    class="txt-white"
                                    >中国证券投资基金业协会</a
                                >
                            </li>
                            <li>
                                <a
                                    href="http://www.samr.gov.cn/"
                                    target="_blank"
                                    class="txt-white"
                                    >国家工商行政管理总局
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="foot-info-rt flex-1 txt-left">
                        <p class="txt-white">联系我们</p>
                        <p class="txt-gray">
                            <span>客服电话：400-18-95522</span>
                            <span>客服传真：010-57697399</span>
                        </p>
                        <p class="txt-gray">
                            客服邮箱：tkfunds@taikangamc.com.cn
                        </p>
                    </div>
                </div>
            </div>
            <div class="txt-gray">
                <div>
                    <p>
                        <!-- <a href="https://newtrade.tkfunds.com.cn/tkapp-web/ExemptionclausePC" target="_blank" class="txt-gray">免责声明</a> -->
                        <a
                            href="https://newtrade.tkfunds.com.cn/tkfile/buinsess/agreement/%E5%85%8D%E8%B4%A3%E5%A3%B0%E6%98%8E.pdf"
                            target="_blank"
                            class="txt-gray"
                            >免责声明</a
                        >
                        &nbsp;|&nbsp;
                        <!-- <a href="https://newtrade.tkfunds.com.cn/tkapp-web/StatementofrisktolerancePC" target="_blank" class="txt-gray">风险提示</a> -->
                        <a
                            href="https://newtrade.tkfunds.com.cn/tkfile/buinsess/agreement/%E9%A3%8E%E9%99%A9%E6%8F%90%E7%A4%BA%E5%87%BD.pdf"
                            target="_blank"
                            class="txt-gray"
                            >风险提示</a
                        >
                    </p>
                    <p>
                        版权所有：<a
                            href="http://www.taikangasset.cn/"
                            target="_blank"
                            class="txt-gray"
                        >
                            泰康资产 - 基金业务官方网站
                        </a>
                        沪ICP备16041640号
                    </p>
                    <p>
                        本网站所有资讯与说明文字仅供参考，如有与本公司相关公告及基金法律文件不符以相关公告及基金法律文件为准（市场有风险，投资需谨慎）
                    </p>
                </div>
            </div>
        </footer>
        <!-- 错误提示 -->
        <model-error>
            <template slot="cancle"
                ><span @click="$tools.hideErrorMsg_model()">X</span></template
            >
            <!--主要内容-->
            <template slot="mdl-content">
                <input type="hidden" id="errorUrl" />
                <p id="errorMsgTip" class="txt-center ft-size-16"></p>
                <!--<div class="txt-center mdl-btn-box">
					<btn-middle @click="$tools.hideErrorMsg_model()">确定</btn-middle>
				</div>-->
            </template>
        </model-error>
        <!--comfirm 弹框提示-->
        <model-confirm>
            <template slot="cancle"
                ><span @click="$tools.hideConfirmMsg_model()">X</span></template
            >
            <!--主要内容-->
            <template slot="mdl-content">
                <input type="hidden" id="confirmOkUrl" />
                <input type="hidden" id="confirmCCUrl" />
                <p
                    id="confirmMsgTip"
                    class="txt-center ft-size-16"
                    style="min-height: 2rem"
                ></p>
                <div class="txt-center mdl-btn-box"></div>
            </template>
        </model-confirm>
        <!--广告弹框-->
        <div
            class="model-container animated-5 fadeIn addv-container"
            v-if="isShowHomeAddv"
        >
            <div class="model-box posi-relative">
                <!-- 主要内容 -->
                <div class="model-content addv-box">
                    <img :src="home_addvUrl" />
                </div>
                <p
                    class="posi-absolute fa fa-close cur-pot"
                    @click="clearADDV"
                ></p>
            </div>
        </div>
        <!-- 错误信息提示 -->
        <model-err-msg />
        <!--最低风险等级,风险不匹警示函,投资者确认书 提示框-->
        <modelRisk
            :fundRisk="fundRisk"
            :userRisk="userRisk"
            :urlpathStart="urlpathStart"
            :miniRisk="isShowMiniRisk"
            :FXBPPJSH="isShowFXBPPJSH"
            @modelHandle="fdRiskHandle"
        />
        <more-time-box v-if="isShowTime" @nextGo="nextGo" @close="closeShowTime" ref="moreBox" :item="start"></more-time-box>
    </section>
</template>
<script>
</script>
<script>
import modelError from "./components/publicCpts/modelErrorCpt"; //-- 错误 信息提示弹框
import modelConfirm from "./components/publicCpts/modelConfirmCpt"; //-- 确认 信息提示弹框
import modelErrMsg from "./components/publicCpts/modelErrMsgCpt"; //-- 错误弹框提示,可自动关闭
import modelRisk from "./components/publicCpts/modelConfirmFXBPPJSH"; //-- 最低风险等级,风险不匹警示函,投资者确认书
import MoreTimeBox from './components/BaseCpts/moreTimeBox.vue';

export default {
    components: { modelError, modelConfirm, modelErrMsg, modelRisk },
    mounted() {
        MoreTimeBox
        //获得 头部重要通知
        //this.getZYTZInfo(this);
        this.getHeadMessage(this);
        //获得 头部下方 公告弹框的 信息列表
        this.getGGTKInfo(this);
        //获得 广告弹框
        this.getHomeBanners(this);
        //页面刷新时
        this.pageReunload();
        //检测屏幕屏幕宽度
        // this.windowResize();
        this.getYourIP()
        let href = window.location.pathname,
            hrefArr = [
                "/tkweb-web/",
                "/tkweb-web",
                "/tkweb-web-pre/",
                "/tkweb-web-pre",
            ];
        if (href.indexOf("login") > 0 || hrefArr.includes(href)) {
            //console.log('login',1111)
            this.$tools.delSession(
                "mobilePhone,login_userName,login_identityNo,login_identityType,online_sessionKey"
            );
            //清空状态里的 state
            this.$store.commit("upUserInfo", null);
            this.$store.commit("upTodoInfo", null);
            this.$store.commit("upRegisterInfo", null);
            this.$tools.delCookie("TKAMC_USERINFO");
            //删除cookie
            this.clearCookie();
        }
    },
    data() {
        return {
            isShowFenHong: false,
            vHtml: '<span data-id="001" class="ceshi">测试</span>',
            home_ZYTZInfoList: "", //重要通知的列表
            isShowHome_ZYTZ: false, //是否显示重要通知
            home_synopsisList: "", //系统公告的列表
            home_synopsis: "", //系统公告信息弹框 内容
            isShowHome_synopsis: false, //是否显示 系统公告
            home_addvUrl: "", //广告弹框
            home_addvId: "", //广告弹框 编号
            isShowHomeAddv: false, //是否显示广告
            localStorage_systemList: "", //已存的已读的信息
            modelVue: "", //-- 当前 风险不匹配的 vue 实例,取 this 用
            isShowMiniRisk: false, //-- 是否显示 最低风险等级
            isShowFXBPPJSH: false, //-- 是否显示 风险不匹警示函
            fundRisk: "", //-- 当前基金的风险等级
            userRisk: "", //-- 当前用户的风险等级
            urlpathStart: "", //--跳转路由指向
            NowPath: "",
            isShowUserInfo: false,
            headMessageList: [], //重要通知列表
            headMessage: "", //滚动的通知
            timer: null, //定时器
            start:{},
            isShowTime:false
        };
    },
    computed: {
        //监听用户信息
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    // 监听路由的动向
    watch: {
        $route(to, from) {
            this.NowPath = to.path;
        },
    },
    methods: {
          getYourIP(){
            var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
            if (RTCPeerConnection) (function () {
                var rtc = new RTCPeerConnection({iceServers:[]});
                if (1 || window.mozRTCPeerConnection) {
                    rtc.createDataChannel('', {reliable:false});
                };
                rtc.onicecandidate = function (evt) {
                    if (evt.candidate) grepSDP("a="+evt.candidate.candidate);
                };
                rtc.createOffer(function (offerDesc) {
                    grepSDP(offerDesc.sdp);
                    rtc.setLocalDescription(offerDesc);
                }, function (e) { console.warn("offer failed", e); });
                var addrs = Object.create(null);
                addrs["0.0.0.0"] = false;
                function updateDisplay(newAddr) {
                    if (newAddr in addrs) return;
                    else addrs[newAddr] = true;
                    var displayAddrs = Object.keys(addrs).filter(function (k) { return addrs[k]; });
                    for(var i = 0; i < displayAddrs.length; i++){
                        if(displayAddrs[i].length > 16){
                            displayAddrs.splice(i, 1);
                            i--;
                        }
                    }
                    if(displayAddrs[0] == undefined){
                      sessionStorage.setItem('newip','10.88.234.83')
                    }else{
                      sessionStorage.setItem('newip',displayAddrs[0])
                    }
                }
                function grepSDP(sdp) {
                    var hosts = [];
                    sdp.split('\r\n').forEach(function (line, index, arr) {
                       if (~line.indexOf("a=candidate")) {
                            var parts = line.split(' '),
                                addr = parts[4],
                                type = parts[7];
                            if (type === 'host') updateDisplay(addr);
                        } else if (~line.indexOf("c=")) {
                            var parts = line.split(' '),
                                addr = parts[2];
                            updateDisplay(addr);
                        }
                    });
                }
            })();
            else{
              console.log("请使用主流浏览器：chrome,firefox,opera,safari")
              sessionStorage.setItem('newip','10.88.234.83')
            }
        },
        // 客服跳转
        Customerservice() {},
        //设置页面的滚动
        setScrollHandel(num) {
            let timer = null,
                appScroll = 0,
                winScroll = 0;
            appScroll = $("#app").scrollTop();
            winScroll = $(window).scrollTop();
            //设置 滚动置顶的动画
            timer = setInterval(function () {
                if (winScroll - 130 > 0) {
                    winScroll = winScroll - 130;
                    $(window).scrollTop(winScroll);
                } else {
                    clearInterval(timer);
                    timer = null;
                    $(window).scrollTop(0);
                }
            }, 10);
        },
        //删除所有cookie
        clearCookie() {
            var date = new Date();
            date.setTime(date.getTime() - 10000);
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (var i = keys.length; i--; ) {
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/tkweb-web-pre/fundsFixed";
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/tkweb-web-pre/fundPurchases";
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/tkweb-web/fundsFixed";
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/tkweb-web/fundPurchases";
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/fundsFixed";
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/fundPurchases";
                    document.cookie =
                        keys[i] +
                        "=''; expires=" +
                        date.toGMTString() +
                        "; path=/";
                }
            }
        },
        //退出登录
        loginOut(url) {
            this.$tools.delSession(
                "mobilePhone,login_userName,login_identityNo,login_identityType,online_sessionKey"
            );
            //清空状态里的 state
            this.$store.commit("upUserInfo", null);
            this.$store.commit("upTodoInfo", null);
            this.$store.commit("upRegisterInfo", null);
            this.$tools.delCookie("TKAMC_USERINFO");
            //删除cookie
            this.clearCookie();
            //跳转至登录页
            this.$router.push({ path: url });
        },
        //获得 广告弹框
        getHomeBanners(that) {
            that.$axios_post("other/banners", { bannerType: "4" })
                .then(
                    (res) => {
                        //console.log('广告弹框',res);
                        if (
                            res.code == "00000000" &&
                            res.dataList &&
                            res.dataList.length > 0
                        ) {
                            //获得已存的 已读的 系统公告
                            let systemList = localStorage["systemList"];
                            //判断是不是已有 已读的，如果有
                            if (systemList) {
                                systemList = JSON.parse(systemList);
                            } else {
                                systemList = [];
                            }
                            //that.isShowHomeAddv = true;
                            //循环判断是否已经 查看过
                            for (let t in res.dataList) {
                                for (let s in systemList) {
                                    if (
                                        res.dataList[t].id == systemList[s].id
                                    ) {
                                        that.isShowHomeAddv = false;
                                    }
                                }
                            }
                            if (that.isShowHomeAddv) {
                                that.home_addvId = res.dataList[0].id;
                                that.home_addvUrl =
                                    res.dataList[0].bannerImgPath;
                            }
                        }
                    },
                    (err) => {
                        throw new Error(err);
                    }
                )
                .catch((err) => {
                    throw new Error(err);
                });
        },
        //获得头部重要通知 (暂时不用)
        getZYTZInfo(that) {
            //获得已存的 已读的 系统公告
            let systemList = localStorage["systemList"];
            //判断是不是已有 已读的，如果有
            if (systemList) {
                systemList = JSON.parse(systemList);
            } else {
                //如果没有，则初始化成 空数组
                systemList = [];
            }
            //获得全部的头部的重要通知  query/user/messages { showState1: "1" }
            that.$axios_post("query/user/show/messages")
                .then(
                    (res) => {
                        //console.log('重要通知',res)
                        if (res.code == "00000000") {
                            that.checkZYTZInfo(that, res.dataList, systemList);
                        }
                    },
                    (err) => {
                        throw new Error(err);
                    }
                )
                .catch((err) => {
                    throw new Error(err);
                });
        },
        //获得头部重要通知跑马灯
        getHeadMessage(that) {
            that.$axios_post("query/user/show/messages").then((res) => {
                console.log("重要通知", res);
                if (res.code == "00000000") {
                    if (res.dataList && res.dataList.length > 0) {
                        let str = "";
                        that.headMessageList = res.dataList;
                        that.headMessageList.map((k, v) => {
                            str += k.synopsis;
                        });
                        that.headMessage = str;
                        that.scrollText();
                    }
                }
            });
        },
        //跑马灯
        scrollText() {
            if (this.timer != null) return;
            this.isShowHome_ZYTZ = true;
            this.timer = setInterval(() => {
                //获取到头的第一个字符
                let start = this.headMessage.substring(0, 1);
                //获取到后面的所有字符
                let end = this.headMessage.substring(1);
                //重新拼接得到新的字符串，并赋值给this.message
                this.headMessage = end + start;
            }, 500);
        },
        messageInfo() {
            if (this.userInfo.token) {
                this.$router.push({ path: "/mymessage" });
            } else {
                //没有登录不让查看，并提示登录
                let strErr = "您还没有登录不能查看<br>";
                this.$tools.showErrorMsg_model(
                    strErr,
                    "/login",
                    "登录提示",
                    "立刻登录"
                );
            }
        },
        //判断展示的重要通知
        checkZYTZInfo(that, dList, sList) {
            let showList = [];
            for (var d in dList) {
                let obj = {
                    id: dList[d].id,
                    phone: this.mobilePhone,
                    jumpUrl: dList[d].jumpUrl,
                    content: dList[d].synopsis,
                };
                if (obj.content.length > 75) {
                    obj.content = obj.content.substr(0, 75) + "...";
                }
                showList.push(obj);
                //如果已读 则 移除，不再显示
                // for (var s in sList) {
                //   // 和App一样，只和设备绑定  sList[s].phone == sessionStorage['tkoltd_mobilePhone'] &&
                //   if (sList[s].id == dList[d].id) {
                //     showList.splice(-1);
                //   }
                // }
            }

            that.home_ZYTZInfoList = showList;
            that.isShowHome_ZYTZ = false; //默认不显示
            //如果条数大约 0 则显示
            if (that.home_ZYTZInfoList.length > 0) {
                // that.isShowHome_ZYTZ = true;
                new that.$swiper(".swiper-container", {
                    autoplay: true,
                    loop: true,
                    speed: 5000,
                });
            }
        },
        //获得头部重要通知跑马灯
        getHeadMessage(that) {
            that.$axios_post("query/user/show/messages").then((res) => {
                console.log("重要通知", res);
                if (res.code == "00000000") {
                    if (res.dataList && res.dataList.length > 0) {
                        let str = "";
                        that.headMessageList = res.dataList;
                        that.headMessageList.map((k, v) => {
                            str += k.synopsis;
                        });
                        that.headMessage = str;
                        that.scrollText();
                    }
                }
            });
        },
        //跑马灯
        scrollText() {
            if (this.timer != null) return;
            this.isShowHome_ZYTZ = true;
            this.timer = setInterval(() => {
                //获取到头的第一个字符
                let start = this.headMessage.substring(0, 1);
                //获取到后面的所有字符
                let end = this.headMessage.substring(1);
                //重新拼接得到新的字符串，并赋值给this.message
                this.headMessage = end + start;
            }, 500);
        },
        messageInfo() {
            if (this.userInfo.token) {
                this.$router.push({ path: "/mymessage" });
            } else {
                //没有登录不让查看，并提示登录
                let strErr = "您还没有登录不能查看<br>";
                this.$tools.showErrorMsg_model(
                    strErr,
                    "/login",
                    "登录提示",
                    "立刻登录"
                );
            }
        },
        //查看重要通知
        zytzLook(item) {
            //如果已经登录
            if (this.userInfo.token) {
                //将已读的保存至 localStorage
                this.localStorage_systemList.push({
                    id: item.id,
                    phone: this.userInfo.mobilePhone,
                    jumpUrl: item.jumpUrl,
                });
                //把已读的转换成 JSON 并更新 localStorage
                let lcsg = JSON.stringify(this.localStorage_systemList);
                localStorage["systemList"] = lcsg;
                //判断系统公告的数量
                if (this.home_ZYTZInfoList.length > 1) {
                    this.home_ZYTZInfoList.shift();
                } else {
                    this.home_ZYTZInfoList = [];
                    this.isShowHome_ZYTZ = false;
                }
                //查看详情，跳转至详情页面
                this.$router.push({ path: "/" });
            } else {
                //没有登录不让查看，并提示登录
                let strErr = "您还没有登录不能查看<br>";
                this.$tools.showErrorMsg_model(
                    strErr,
                    "/login",
                    "登录提示",
                    "立刻登录"
                );
            }
        },
        //获得公告弹框信息
        getGGTKInfo(that) {
            //获得已存的 已读的 系统公告
            let systemList = localStorage["systemList"];
            //判断是不是已有 已读的，如果有
            if (systemList) {
                systemList = JSON.parse(systemList);
            } else {
                //如果没有，则初始化成 空数组
                systemList = [];
            }
            that.localStorage_systemList = systemList;
            //获得全部的  系统公告 "query/user/messages" { showState: "1" }
            that.$axios_post("query/user/show/messages")
                .then((res) => {
                    //console.log('系统公告',res)
                    if (res.code == "00000000") {
                        that.checkGGTKInfo(that, res.dataList, systemList);
                    }
                })
                .catch((err) => {
                    throw new Error(err);
                });
        },
        //判断展示的系统公告
        checkGGTKInfo(that, dList, sList) {
            let showList = [];
            for (var d in dList) {
                showList.push(dList[d]);
                //如果已读则 移除，不再显示
                for (var s in sList) {
                    // 和App一样，只和设备绑定   sList[s].phone == sessionStorage['tkoltd_mobilePhone'] &&
                    if (sList[s].id == dList[d].id) {
                        showList.splice(-1);
                    }
                }
            }
            //默认显示第一个 通知公告
            if (showList.length > 1) {
                that.home_synopsisList = showList;
                that.home_synopsis = showList[0].synopsis;
                that.isShowHome_synopsis = true;
            }
        },
        //关闭公告弹框
        clearGGTK(strType) {
            //将已读的保存至 localStorage
            this.localStorage_systemList.push({
                id: this.home_synopsisList[0].id,
                phone: this.userInfo.mobilePhone,
                jumpUrl: this.home_synopsisList[0].jumpUrl,
            });
            //把已读的转换成 JSON 并更新 localStorage
            let lcsg = JSON.stringify(this.localStorage_systemList);
            localStorage["systemList"] = lcsg;
            //判断系统公告的数量
            if (this.home_synopsisList.length > 1) {
                this.home_synopsisList.shift();
                this.home_synopsis = this.home_synopsisList[0].synopsis;
            } else {
                this.home_synopsis = "";
                this.isShowHome_synopsis = false;
            }
            //查看详情，跳转至详情页面
            if (strType == 2) {
                //如果已经登录
                if (this.userInfo.token) {
                    this.$router.push({ path: "/" });
                } else {
                    //没有登录不让查看，并提示登录
                    let strErr = "您还没有登录不能查看<br>";
                    this.$tools.showErrorMsg_model(
                        strErr,
                        "/login",
                        "登录提示",
                        "立刻登录"
                    );
                }
            }
        },
        //关闭广告弹框
        clearADDV(strType) {
            this.home_addvUrl = ""; //广告弹框的 图片地址
            this.isShowHomeAddv = false;
            //将已读的保存至 localStorage
            this.localStorage_systemList.push({
                id: this.home_addvId,
                phone: this.userInfo.mobilePhone,
                jumpUrl: this.home_addvUrl,
            });
            //把已读的转换成 JSON 并更新 localStorage
            let lcsg = JSON.stringify(this.localStorage_systemList);
            localStorage["systemList"] = lcsg;
            // console.log(this.localStorage_systemList)
            //查看详情，跳转至详情页面
            if (strType == 2) {
                //如果已经登录
                if (this.userInfo.token) {
                    this.$router.push({ path: "/" });
                } else {
                    //没有登录不让查看，并提示登录
                    let strErr = "您还没有登录不能查看<br>";
                    this.$tools.showErrorMsg_model(
                        strErr,
                        "/login",
                        "登录提示",
                        "立刻登录"
                    );
                }
            }
        },
        //页面刷新时
        pageReunload() {
            //-- 全局监听，页面刷新的时候将store里state的值存到sessionStorage中，然后从sessionStorage中获取，再赋值给store。
            //-- 然后再把session里面存的删除即可，相当于中间件的作用。
            //-- 在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem("store"))
                    )
                );
                //this.upStateInfo();
                this.$store.commit("showErrorInfo", null);
            }
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem(
                    "store",
                    JSON.stringify(this.$store.state)
                );
            });
        },
        //显示错误信息(中上方有一横条，会的自动消失)
        showErrorMsgMini(errorInfo) {
            if (errorInfo instanceof Object) {
                this.$store.commit("showErrorInfo", errorInfo);
            } else {
                this.$store.commit("showErrorInfo", {
                    type: "fail",
                    msg: errorInfo,
                });
            }
        },
        //基金的风险等级 的判断
        fdRiskLevel(that, start, newPath) {
            //当前 风险不匹配的 vue 实例,取 this 用
            this.modelVue = that;
            let riskLevel = this.userInfo.riskAbility,
            riskLevelDesc = this.userInfo.riskAbilityDesc;
            console.log('this.modelVue',this.modelVue);
            // console.log('riskLevel',riskLevel);
            // console.log('riskLevelDesc',riskLevelDesc);
            //判断 风险等级是否过期，0没过期，1过期
            // console.log(this.userInfo.userType,this.userInfo.riskFlag)
            if (this.userInfo.userType < 2) {
                let strErr = "该操作需开设基金账户,<br>是否立即前往？";
                // this.$tools.showErrorMsg_model(
                //   strErr,
                //   "/register/bank",
                //   "开户提醒",
                //   "立即前往",
                //   true
                // );
                this.$tools.showConfirmMsg_model(
                    "您已注册成功！<br/><br/>还没有添加基金交易银行卡，暂时无法进行基金申购，定投等交易功能。",
                    "/register/bank",
                    "",
                    "立即前往",
                    "关闭",
                    "开户提示"
                );
            } else if (this.userInfo.riskFlag == 1) {
                let strErr =
                    "您的风险评测已过期，请尽快重新评测，以免影响您的正常交易。";
                this.$tools.showConfirmMsg_model(
                    strErr,
                    "/fengxianceping",
                    "",
                    "立刻前往",
                    "稍后再说",
                    "风险评测过期"
                );
            } else {
              
                // console.log('00',riskLevel , that.fundRiskObj.fundRiskLevel)
                //如果风险等级不匹配 进行提示，否则 可购买
                this.start = start
                if (riskLevel >= that.fundRiskObj.fundRiskLevel + 1) {
                  this.isShowTime = true
                  setTimeout(()=>{
                    console.log(this.$refs.moreBox.isNext,'true是没有弹窗！')
                    if(this.$refs.moreBox&&this.$refs.moreBox.isNext){
                      this.isShowTime = false
                      if (that.fundRiskObj.linkToUrl) {
                        that.$router.push({
                            path: that.fundRiskObj.linkToUrl,
                            query: {
                                fundCode: this.modelVue.fundRiskObj.fundCode,
                            },
                        });
                      }
                    }
                  },100)
                } else {
                    // 判断是不是 最低风险等级
                    if (this.userInfo.minRiskFlag == 1) {
                        this.userRisk = "C1(最低风险承受能力)";
                        this.isShowMiniRisk = true; // 显示最低风险等级提示
                        this.urlpathStart = newPath == undefined?start:newPath;
                        // console.log("start最低风险承受能力",start)
                        // console.log("this.urlpathStart最低风险承受能力",this.urlpathStart)
                    } else {
                        this.isShowFXBPPJSH = true; // 显示风险不匹警示函
                        this.fundRisk = that.fundRiskObj.fundRiskLevelDesc; // 当前基金的风险等级
                        this.userRisk = riskLevel; // 当前用户的风险等级
                        // console.log('riskLevel',this.fundRisk )
                        this.urlpathStart = newPath == undefined?start:newPath;
                        // console.log("startNO",start)
                        // console.log("this.urlpathStartNO",this.urlpathStart)
                    }
                }
            }                  
        },
        nextGo(){
          this.isShowTime = false
          if (this.modelVue.fundRiskObj.linkToUrl) {
              this.$router.push({
                  path: this.modelVue.fundRiskObj.linkToUrl,
                  query: {
                      fundCode: this.modelVue.fundRiskObj.fundCode,
                  },
              });
            }
        },
        closeShowTime(){
          this.isShowTime = false
          if (this.modelVue.fundRiskObj.type == "fixed") {
              //如果是新增定投
              this.modelVue.fundSltIndex = "";
              this.modelVue.fundInfoSlt = "";
              this.modelVue.fundName = "";
          } else if (this.modelVue.fundRiskObj.type == "transform") {
              //如果是新增预约转换
              this.modelVue.fundSltIndexZR = "";
              this.modelVue.fundInfoSltZR = "";
              this.modelVue.fundNameZR = "";
              this.modelVue.fundSltIndex = "";
              this.modelVue.fundInfoSlt = "";
              this.modelVue.fundName = "";
          } else if (this.modelVue.fundRiskObj.type == "renGou") {
              //如果是新增赎回转认购
              this.modelVue.fundInfoRGIndex = "";
              this.modelVue.fundInfoRG = { fundName: "" };
          }else if (this.modelVue.fundRiskObj.type == "shenGou") {
              //如果是新增赎回转申购
              this.modelVue.$refs.shengou.clearSltVal()
          } else if (this.modelVue.fundRiskObj.type == "YYrenGou") {
              //如果是 预约认购
              this.modelVue.fundInfo = {
                  firstSubscribeMinSum: "",
                  firstBuyMinSum: "",
              };
              this.modelVue.fundInfoSlt = "";
              this.modelVue.money = "";
          }
          if (
              this.modelVue.$refs.fdRef &&
              this.modelVue.$refs.fdRef.clearSltVal
          ) {
              this.modelVue.$refs.fdRef.clearSltVal();
          }
        },
        //基金的风险等级 的判断 放弃事件
        fdRiskHandle(fnType) {
            // console.log('fnType',fnType)
            // console.log('fnType',this.modelVue.fundRiskObj)
            this.isShowMiniRisk = false;
            this.isShowFXBPPJSH = false;
            //判断是不是可以跳转
            this.isShowTime = true
            if (fnType && this.modelVue.fundRiskObj.linkToUrl) {
              setTimeout(()=>{
                if(this.$refs.moreBox&&this.$refs.moreBox.isNext){
                  this.isShowTime = false
                  this.$router.push({
                      path: this.modelVue.fundRiskObj.linkToUrl,
                      query: { fundCode: this.modelVue.fundRiskObj.fundCode },
                  });
                }
              },100)              
            } else if (!fnType) {
                this.isShowTime = false
                if (this.modelVue.fundRiskObj.type == "fixed") {
                    //如果是新增定投
                    this.modelVue.fundSltIndex = "";
                    this.modelVue.fundInfoSlt = "";
                    this.modelVue.fundName = "";
                } else if (this.modelVue.fundRiskObj.type == "transform") {
                    //如果是新增预约转换
                    this.modelVue.fundSltIndexZR = "";
                    this.modelVue.fundInfoSltZR = "";
                    this.modelVue.fundNameZR = "";
                    this.modelVue.fundSltIndex = "";
                    this.modelVue.fundInfoSlt = "";
                    this.modelVue.fundName = "";
                } else if (this.modelVue.fundRiskObj.type == "renGou") {
                    //如果是新增赎回转认购
                    this.modelVue.fundInfoRGIndex = "";
                    this.modelVue.fundInfoRG = { fundName: "" };
                } else if (this.modelVue.fundRiskObj.type == "shenGou") {
                    //如果是新增赎回转申购
                    this.modelVue.$refs.shengou.clearSltVal()
                }else if (this.modelVue.fundRiskObj.type == "YYrenGou") {
                    //如果是 预约认购
                    this.modelVue.fundInfo = {
                        firstSubscribeMinSum: "",
                        firstBuyMinSum: "",
                    };
                    this.modelVue.fundInfoSlt = "";
                    this.modelVue.money = "";
                }
                if (
                    this.modelVue.$refs.fdRef &&
                    this.modelVue.$refs.fdRef.clearSltVal
                ) {
                    this.modelVue.$refs.fdRef.clearSltVal();
                }
            }else{
              setTimeout(()=>{
                if(this.$refs.moreBox&&this.$refs.moreBox.isNext){
                  // debugger
                  this.isShowTime = false
                }
              },100)
            }
        },
        //删除信息
        delStateInfo() {
            this.$store.commit("upUserInfo", null);
            this.$nextTick(() => {
                this.$store.commit("upUserInfo", null);
                this.$nextTick(() => {
                    this.$store.commit("upUserInfo", null);
                    // console.log(this.$store);
                });
            });
        },
        upStateInfo() {
            setTimeout(() => {
                let tmp = JSON.parse(this.$tools.getCookie("TKAMC_USERINFO"));
                if (tmp) {
                    tmp.tmpDate = new Date().getTime();
                    this.$store.commit("upUserInfo", null);
                    this.$store.commit("upUserInfo", tmp);
                }
                this.$store.commit("showErrorInfo", null);
                // console.log(this.$store);
            }, 55);
        },
        //检测屏幕宽度
        windowResize() {
            //生成一个a元素 并 创建单击事件 d6bc0875c39f46b6a08e8cd3e4645442
            // let a = document.createElement("a"), event = new MouseEvent("click");
            // a.href = 'https://newtrade.tkfunds.com.cn/tkwechat-web-pre/loginbind';
            //如果一进来就是小屏幕
            // if($(document).width() < 1100 || $(window).width() < 1100){
            //     // 触发a的单击事件
            //     a.dispatchEvent(event);
            // }
            //如果屏幕变化后是小屏幕
            // $(window).resize(function(res){
            //     if($(document).width() < 1100 || $(window).width() < 1100){
            //         // 触发a的单击事件
            //         a.dispatchEvent(event);
            //     }
            // });
            // 移除 已存的 银行鉴权的 callBackId
            if (localStorage) {
                for (let v in localStorage) {
                    if (v.indexOf("_callBackId")) {
                        localStorage.removeItem(v);
                    }
                }
            }
            setTimeout(() => {
                if (this.$route.path != "/fundsFixed/buy") {
                    this.delStateInfo();
                }
            }, 50);
        },
    },
};
</script>

<style scoped lang="less">
#app {
    min-width: 1100px;
    height: 100%;
    background: #f7f7f7;
}
/********* 页头 ********/
/*logo*/
.top-box {
    .logo-box {
        height: 5rem;
        padding: 0.5rem 0;
        div.login-register-box {
            p:first-child {
                padding: 1.45rem 0 0.2rem 0;
            }
        }
    }
    .logined {
        span:last-child:hover {
            text-decoration: underline;
        }
    }
}
/*导航*/
.nav-box {
    height: 2rem;
    background: #d20600;
    > div {
        justify-content: center;
        background: #d20600;
    }
    > div p a {
        display: inline-block;
        padding: 0 2.4rem;
        line-height: 2rem;
        font-size: 0.75rem;
        color: #fff !important;
    }
    > div p.active {
        background: #a80500;
    }
}

/*重要通知*/
.top-box {
    margin-bottom: 1rem;
    > div.news-box {
        padding: 0.5rem 0;
        background: #fcfcfc;
        border-bottom: 0.05rem solid #f1f1f1;
        .swiper-container {
            flex: 1;
            overflow: hidden;
        }
        .swiper-container .swiper-wrapper {
            height: 0.8rem;
        }
    }
}

/*系统公告弹框*/
.ggtk-box {
    background: #f7f7f7;
    padding-top: 1rem;
    > div {
        background: #fff;
        width: 60rem;
        margin: 0 auto;
        /*头部标题*/
        .ggtk-top {
            padding: 0.55rem 1rem;
            p:first-child {
                font-weight: 500;
                font-size: 0.8rem;
                i {
                    margin-right: 0.3rem;
                    color: #c02a1b;
                }
            }
            p:last-child {
                img {
                    width: 0.8rem;
                    height: 0.8rem;
                    cursor: pointer;
                }
            }
            border-bottom: 0.05rem solid #ebebeb;
        }
        /*弹框内容*/
        .ggtk-content {
            padding: 0.45rem 0.8rem;
            line-height: 26px;
            font-size: 14px;
            font-weight: 400;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
        }
    }
}

/*广告弹框*/
.addv-container {
    display: block;
    .model-box {
        min-height: 5rem;
        min-width: 5rem;
        width: auto;
        max-width: 30rem;
        top: 13%;
        img {
            max-width: 100%;
            max-height: 20rem;
        }
        > p {
            top: -0.7rem;
            right: -0.7rem;
            width: 1.5rem;
            height: 1.5rem;
            font-size: 1rem;
            background: #fff;
            border: 2px solid rgba(51, 51, 51, 1);
            border-radius: 50%;
            text-align: center;
            line-height: 1.3rem;
        }
    }
}
/********* 页脚 *********/
.foot-box {
    background: #000;
    margin-top: 1rem;
    margin-top: 1rem;
    > div:first-child {
        background: #262626;
        > div {
            background: #262626;
            padding: 1.4rem 0;
            .foot-info-lf p:first-child,
            .foot-info-rt p:first-child {
                padding-bottom: 1rem;
            }
            /** 友情链接 **/
            .foot-info-lf {
                width: 60%;
                text-align: left;
                ul li {
                    padding-right: 1rem;
                }
            }
            /** 联系我们 **/
            .foot-info-rt {
                p:nth-child(2) {
                    span {
                        padding-right: 1rem;
                    }
                }
                p:nth-child(3) {
                    padding-top: 0.8rem;
                }
            }
        }
    }
    /*底部版权信息*/
    > div:last-child {
        background: #000;
        padding: 1.4rem 0;
        div {
            width: 60rem;
            margin: 0 auto;
            background: #000;
            p:nth-child(2) {
                padding: 1rem 0;
            }
        }
    }
}
/*错误信息弹框*/
.model-tip-msg {
    background: rgba(0, 0, 0, 0.2);
    display: none;
}

.model-tip-box {
    width: 566px;
    height: 166px;
    margin-left: -283px;
    border-radius: 5px;
    top: 20%;
    left: 50%;
    box-shadow: 0 2px 15px 1px #2d2d2d;
    > p:first-child {
        padding: 5px 8px;
        border-radius: 3px 3px 0 0;
    }
    > p:nth-child(2) {
        margin-top: 36px;
    }
    > p:nth-child(3) {
        margin-top: 30px;
        span {
            display: inline-block;
            padding: 6px 30px;
            margin-right: 15px;
            border-radius: 3px;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/App.vue